var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticClass: "search_group" },
        [
          _c("el-input", {
            attrs: {
              maxlength: 30,
              size: "small",
              placeholder: "输入订单编号",
            },
            model: {
              value: _vm.orderNo,
              callback: function ($$v) {
                _vm.orderNo = $$v
              },
              expression: "orderNo",
            },
          }),
          _c("el-input", {
            attrs: { maxlength: 30, size: "small", placeholder: "用户账户" },
            model: {
              value: _vm.userAccount,
              callback: function ($$v) {
                _vm.userAccount = $$v
              },
              expression: "userAccount",
            },
          }),
          _c("el-date-picker", {
            attrs: {
              type: "date",
              "value-format": "yyyy-MM-dd",
              size: "small",
              placeholder: "申请时间",
            },
            model: {
              value: _vm.searchTime,
              callback: function ($$v) {
                _vm.searchTime = $$v
              },
              expression: "searchTime",
            },
          }),
          _c(
            "el-select",
            {
              attrs: { size: "small", clearable: "", placeholder: "补单状态" },
              on: { change: _vm.searchAct },
              model: {
                value: _vm.searchStatus,
                callback: function ($$v) {
                  _vm.searchStatus = $$v
                },
                expression: "searchStatus",
              },
            },
            [
              _c("el-option", { attrs: { label: "待处理", value: 1 } }),
              _c("el-option", { attrs: { label: "已补单", value: 2 } }),
              _c("el-option", { attrs: { label: "已拒绝", value: 3 } }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              attrs: { size: "small", clearable: "", placeholder: "支付方式" },
              on: { change: _vm.searchAct },
              model: {
                value: _vm.payType,
                callback: function ($$v) {
                  _vm.payType = $$v
                },
                expression: "payType",
              },
            },
            [
              _c("el-option", { attrs: { label: "微信", value: 1 } }),
              _c("el-option", { attrs: { label: "支付宝", value: 2 } }),
              _c("el-option", { attrs: { label: "IOS内购", value: 5 } }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-search", size: "small", type: "primary" },
              on: { click: _vm.searchAct },
            },
            [_vm._v("查询")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "auth",
                  rawName: "v-auth",
                  value: "memberFix_export",
                  expression: "'memberFix_export'",
                },
              ],
              attrs: {
                icon: "el-icon-download",
                size: "small",
                type: "primary",
              },
              on: { click: _vm.exportList },
            },
            [_vm._v("导出")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            "cell-style": { "text-align": "center" },
            "header-cell-style": { "text-align": "center" },
            "max-height": _vm.tableHeight,
            "element-loading-text": "加载中",
            border: "",
            data: _vm.tableData,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              prop: "orderId",
              label: "订单编号",
              width: "200",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "productName", label: "补单商品名称", width: "150" },
          }),
          _c("el-table-column", {
            attrs: { prop: "producTypetName", label: "商品类型", width: "120" },
          }),
          _c("el-table-column", {
            attrs: { prop: "mobile", label: "用户账号", width: "120" },
          }),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "申请时间", width: "180" },
          }),
          _c("el-table-column", {
            attrs: { label: "支付方式" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(_vm._f("payType")(scope.row.payType)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "用户凭证" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-image", {
                      attrs: {
                        fit: "fill",
                        src: scope.row.attachment,
                        "preview-src-list": [scope.row.attachment],
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "补单状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("fixStatus")(scope.row.supplementReviewStatus)
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "reviewTime", label: "处理时间", width: "180" },
          }),
          _c("el-table-column", {
            attrs: { prop: "reviewUserName", label: "处理人" },
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", width: "150", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.supplementReviewStatus == 1
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "memberFix_handle",
                                expression: "'memberFix_handle'",
                              },
                            ],
                            attrs: {
                              icon: "el-icon-info",
                              size: "mini",
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openDetail(scope.row, 2)
                              },
                            },
                          },
                          [_vm._v("处理补单")]
                        )
                      : _vm._e(),
                    scope.row.supplementReviewStatus != 1
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "memberFix_detail",
                                expression: "'memberFix_detail'",
                              },
                            ],
                            attrs: {
                              icon: "el-icon-info",
                              size: "mini",
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openDetail(scope.row, 1)
                              },
                            },
                          },
                          [_vm._v("查看详情")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table_pagination" },
        [
          _c("el-pagination", {
            staticClass: "app-pagination",
            attrs: {
              background: "",
              "current-page": _vm.pageNo,
              "page-sizes": _vm.pageSizeArr,
              "page-size": _vm.pageSize,
              layout: _vm.paginationLayout,
              total: _vm.totalEl,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "订单详情",
            visible: _vm.showDetails,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDetails = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.checkItem,
                size: "mini",
                "label-position": "left",
                "label-width": "140px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "订单编号" } }, [
                _vm._v(_vm._s(_vm.checkItem.orderId)),
              ]),
              _c("el-form-item", { attrs: { label: "用户账号" } }, [
                _vm._v(_vm._s(_vm.checkItem.mobile)),
              ]),
              _c("el-form-item", { attrs: { label: "订单商品名称" } }, [
                _vm._v(_vm._s(_vm.checkItem.productName)),
              ]),
              _c(
                "el-form-item",
                {
                  staticClass: "form-upload-img",
                  attrs: { label: "用户凭证" },
                },
                [
                  _c("img", {
                    attrs: { src: _vm.checkItem.attachment, alt: "" },
                  }),
                ]
              ),
              _c("el-form-item", { attrs: { label: "支付方式" } }, [
                _vm._v(_vm._s(_vm._f("payType")(_vm.checkItem.payType))),
              ]),
              _c("el-form-item", { attrs: { label: "订单创建时间" } }, [
                _vm._v(_vm._s(_vm.checkItem.orderId)),
              ]),
              _c("el-form-item", { attrs: { label: "申请操作人" } }, [
                _vm._v(_vm._s(_vm.checkItem.reviewCreateName)),
              ]),
              _c("el-form-item", { attrs: { label: "申请操作时间" } }, [
                _vm._v(_vm._s(_vm.checkItem.createTime)),
              ]),
              _c("h3", [_vm._v("补单信息")]),
              _c("el-form-item", { attrs: { label: "补单商品名称" } }, [
                _vm._v(_vm._s(_vm.checkItem.productName)),
              ]),
              _c("el-form-item", { attrs: { label: "补单状态" } }, [
                _vm._v(
                  _vm._s(
                    _vm._f("fixStatus")(_vm.checkItem.supplementReviewStatus)
                  )
                ),
              ]),
              _vm.checkItem.detailType == 1
                ? [
                    _c("el-form-item", { attrs: { label: "处理人" } }, [
                      _vm._v(_vm._s(_vm.checkItem.reviewUserName)),
                    ]),
                    _c("el-form-item", { attrs: { label: "处理时间" } }, [
                      _vm._v(_vm._s(_vm.checkItem.reviewTime)),
                    ]),
                    _c("el-form-item", { attrs: { label: "备注" } }, [
                      _vm._v(_vm._s(_vm.checkItem.reviewContent)),
                    ]),
                  ]
                : _vm._e(),
              _vm.checkItem.detailType == 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "备注" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          maxlength: 150,
                          resize: "none",
                          placeholder: "请输入备注",
                        },
                        model: {
                          value: _vm.handleRemark,
                          callback: function ($$v) {
                            _vm.handleRemark = $$v
                          },
                          expression: "handleRemark",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.checkItem.detailType == 1
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-circle-check",
                      },
                      on: {
                        click: function ($event) {
                          _vm.showDetails = false
                        },
                      },
                    },
                    [_vm._v("确认")]
                  )
                : _vm._e(),
              _vm.checkItem.detailType == 2
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "memberFix_handle",
                          expression: "'memberFix_handle'",
                        },
                      ],
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-circle-check",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeCheck(2)
                        },
                      },
                    },
                    [_vm._v("确认补单")]
                  )
                : _vm._e(),
              _vm.checkItem.detailType == 2
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "memberFix_handle",
                          expression: "'memberFix_handle'",
                        },
                      ],
                      attrs: {
                        size: "small",
                        type: "danger",
                        icon: "el-icon-circle-close",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeCheck(3)
                        },
                      },
                    },
                    [_vm._v("拒绝补单")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }